import * as React from 'react';
import {FunctionComponent} from 'react';
import {
    LeaderboardCategory,
    LeaderboardCategoryType,
    LeaderboardSuggestion,
} from '../../../Models/LeaderboardSuggestion';
import {Bucket} from '../../Components/Utils/Bucket';
import {classNames} from '../../Support/classNames';
import {formatDuration} from '../../Support/Formatting/formatDuration';
import {formatDistance} from '../../Support/Formatting/formatDistance';

interface OwnProps {
    leaderboardSuggestions: LeaderboardSuggestion[];
    className?: string;
}

function leaderboardCategoryText(leaderboardCategory: LeaderboardCategory): {formatted: string; unit?: string} {
    switch (leaderboardCategory) {
        case LeaderboardCategory.Distance100:
            return {formatted: '100', unit: 'm'};
        case LeaderboardCategory.Distance250:
            return {formatted: '250', unit: 'm'};
        case LeaderboardCategory.Distance500:
            return {formatted: '500', unit: 'm'};
        case LeaderboardCategory.Distance1000:
            return {formatted: '1', unit: 'k'};
        case LeaderboardCategory.Distance2000:
            return {formatted: '2', unit: 'k'};
        case LeaderboardCategory.Distance5000:
            return {formatted: '5', unit: 'k'};
        case LeaderboardCategory.Distance6000:
            return {formatted: '6', unit: 'k'};
        case LeaderboardCategory.Distance10000:
            return {formatted: '10', unit: 'k'};
        case LeaderboardCategory.Time60:
            return {formatted: '1', unit: 'min'};
        case LeaderboardCategory.Time1800:
            return {formatted: '30', unit: 'min'};
        case LeaderboardCategory.Time3600:
            return {formatted: '1', unit: 'h'};
    }
}

export const LeaderboardSuggestions: FunctionComponent<OwnProps> = ({leaderboardSuggestions, className}) => {
    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Leaderboard</h5>
            </div>
            <div className="card-body">
                {leaderboardSuggestions.length === 0 && (
                    <>
                        <p>See how you compare to other rowing enthusiasts.</p>
                        <p>Submit your times to the leaderboard by executing a training!</p>
                    </>
                )}
                {leaderboardSuggestions.length > 0 && <p>You have eligible times for the leadboard!</p>}
                {leaderboardSuggestions.map((leaderboardSuggestion) => (
                    <a
                        href={`leaderboard/entries/prepare/${leaderboardSuggestion.workout_interval_id}/${leaderboardSuggestion.category}`}
                    >
                        <div className="mb-3">
                            <div className="row">
                                <div className="col-12">
                                    <div className="badge rounded-pill bg-primary mb-1 me-1">Suggested</div>
                                    <div className="badge rounded-pill bg-dark mb-1">
                                        {leaderboardSuggestion.season}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 d-flex flex-row gap-1">
                                    <Bucket
                                        small
                                        blue
                                        value={leaderboardCategoryText(leaderboardSuggestion.category)}
                                        label="Category"
                                    />
                                    {leaderboardSuggestion.category_type === LeaderboardCategoryType.Distance && (
                                        <Bucket
                                            small
                                            blue
                                            value={formatDuration(leaderboardSuggestion.duration)}
                                            label="Time"
                                        />
                                    )}
                                    {leaderboardSuggestion.category_type === LeaderboardCategoryType.Time && (
                                        <Bucket
                                            small
                                            blue
                                            value={formatDistance(leaderboardSuggestion.distance)}
                                            label="Distance"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </a>
                ))}
                <div className="d-flex flex-row justify-content-end">
                    <a href="/leaderboard/about">Learn more</a>
                </div>
            </div>
        </div>
    );
};
